import React, { useContext, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Loading from "../component/global/Loading";
import ToastContext from "../component/global/ToastContext";
import { LOGIN_ADDRESS } from "../helperData/ApiAddress";
import { GlobalStateContext } from "./GlobalStates";
import { post } from "../controlers/global/ConfigRequest";
import { useTranslation } from "react-i18next";
import AppShellNav from "./AppShellNav";
import AppRoutes from "../routes/AppRoutes";
import {
    applyTokenResponse,
    clearAuthSession,
    isAuthenticated,
    loadAuthFromSession,
} from "../helperData/panelRoutes";

const AppContent = () => {
    const { auth, setAuth } = useContext(GlobalStateContext);
    const [loading, setLoading] = React.useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        let cancelled = false;

        const finish = () => {
            if (!cancelled) {
                setLoading(false);
            }
        };

        const stored = loadAuthFromSession();
        if (stored) {
            setAuth(stored);
            finish();
            return () => {
                cancelled = true;
            };
        }

        const refreshToken = window.localStorage.getItem("refresh_token");
        if (!refreshToken) {
            clearAuthSession();
            finish();
            return () => {
                cancelled = true;
            };
        }

        post(LOGIN_ADDRESS, {
            refresh_token: refreshToken,
            grant_type: "refresh_token",
        })
            .then((response) => {
                if (cancelled) return;
                applyTokenResponse(setAuth, response);
            })
            .catch(() => {
                if (!cancelled && !isAuthenticated(loadAuthFromSession())) {
                    clearAuthSession();
                }
            })
            .finally(finish);

        return () => {
            cancelled = true;
        };
    }, [setAuth]);

    return (
        <>
            {loading ? (
                <div className="main-please-wait">
                    {t("Src.Layouts.AppContent.MainPleaseWait")}
                </div>
            ) : (
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <React.Suspense fallback={Loading}>
                        <ToastContext>
                            <AppRoutes />
                        </ToastContext>
                    </React.Suspense>
                    <AppShellNav />
                </BrowserRouter>
            )}
        </>
    );
};

export default AppContent;
